export function formatSalesLeadDate(value) {
    if (value == null || value === '') return '';
    const s = String(value).trim();
    if (!s) return '';

    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;

    const slash = s.match(/^(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})/);
    if (slash) {
        const m = String(slash[2]).padStart(2, '0');
        const d = String(slash[3]).padStart(2, '0');
        return `${slash[1]}-${m}-${d}`;
    }

    const parsed = Date.parse(s);
    if (!Number.isNaN(parsed)) {
        const dt = new Date(parsed);
        if (!Number.isNaN(dt.getTime())) {
            const y = dt.getFullYear();
            const m = String(dt.getMonth() + 1).padStart(2, '0');
            const d = String(dt.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        }
    }

    return s.length >= 10 ? s.slice(0, 10) : s;
}
